import type { HpChoiceForm } from "../../store/hpChoiceSlice";

interface SchemaZone {
    emetteur_schemaCode: string | number;
}

/** Compute from the actual calculation inputs, including unsaved help alternatives. */
export function getProjectSchemaCode(
    form: Pick<HpChoiceForm, "releveChaudiere" | "typeECS">,
    zones: readonly SchemaZone[] = [],
): string {
    let code = form.releveChaudiere === "chaudiere" ? "-1" : "";
    code += form.typeECS !== "sans" ? "-2" : "";
    code += zones.length === 2 ? "-3" : zones.length === 3 ? "-5" : "";
    zones.forEach((zone, index) => {
        code += "-" + zone.emetteur_schemaCode + (index + 1);
    });
    return code;
}